import React from 'react'
import BigCommerceSync from './BigCommerceSync'
import Shopify from './Shopify'
import Vendor from './Vendor'
import WixSync from './WixSync'
import Wordpress from './Wordpress'

export default function ProductSync() {
  return (
    <div>
        <Shopify/>
        <WixSync/>
        <BigCommerceSync/>
        <Wordpress/>
        <Vendor/>
    </div>
  )
}
